import * as tslib_1 from "tslib";
import { BaseComponent } from "../../base/base.component";
import { AppComponent } from "../../app.component";
import { ActivatedRoute, Router } from "@angular/router";
import { Location } from "@angular/common";
import { AlertUtils } from "../../../crossconcern/utilities/utils/alert.utils";
var NurseriesSphereComponent = /** @class */ (function (_super) {
    tslib_1.__extends(NurseriesSphereComponent, _super);
    function NurseriesSphereComponent(appComponent, router, location, activeRoute, alertUtils) {
        var _this = _super.call(this, appComponent, router, alertUtils, location) || this;
        _this.appComponent = appComponent;
        _this.router = router;
        _this.location = location;
        _this.activeRoute = activeRoute;
        _this.alertUtils = alertUtils;
        return _this;
    }
    NurseriesSphereComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.activeRoute.params.subscribe(function (params) {
            _this.nurseryUUID = params.id;
        });
        this.activeRoute.queryParams.subscribe(function (params) {
            _this.startUUID = params.start;
        });
    };
    return NurseriesSphereComponent;
}(BaseComponent));
export { NurseriesSphereComponent };
